import { Component, Input } from "@angular/core";
import { SpartaxFormStepBaseComponent } from "../spartax-form-step-base";
import { SpartaxCQBaseDataDto } from "src/app/data/dto/spartax/spartax-cq.dto";
import * as moment from "moment";

@Component({
    selector: 'app-spartax-cq-procedure',
    templateUrl: './spartax-cq-procedure.component.html',
    styleUrls: ['./spartax-cq-procedure.component.scss'],
})
export class SpartaxCQProcedureComponent extends SpartaxFormStepBaseComponent {
    @Input()
    baseData: SpartaxCQBaseDataDto;

    public get isBookEvent() {
        return this.model.cqMode === 'bookEvent';
    }

    public get isSelfCheck() {
        return this.model.cqMode === 'selfCheck';
    }

    public get lastYear(): number {
        return moment().year() - 1;
    }

    override formIsValid(): boolean {
        //if 'bookEvent' is selected the questionnaire ends with this choice
        return this.model.cqMode === 'selfCheck';
    }

    onCheckboxChange(mode: 'bookEvent' | 'selfCheck') {
        if (this.model.cqMode === mode) {
            this.model.cqMode = null;
        }
        setTimeout(() => {
            this.model.cqMode = mode;
        }, 0);
    }
}
